module.exports = __webpack_public_path__ + "img/paylines-low.cecf1244.svg";